import { PageSpinner } from "@components/layouts/content/PageSpinner";
import PageWithDynamicZoneLayout from "@components/layouts/content/PageWithDynamicZoneLayout";
import { createPageElement } from "@modules/content/creators/createPageElement";
import { usePageData } from "@modules/content/hooks/usePageData";
import { ContentPage } from "@modules/content/types";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";

export const Home = createPageElement(({ pageId, context }, ref) => {
  const { pageData, refresh, isLoading } = usePageData(
    {
      pageId: pageId ?? "",
      context,
    },
    ref
  );

  if (!pageData || pageData.id !== pageId) {
    return <HomePageLoading isLoading={isLoading} />;
  }

  return (
    <PageWithDynamicZoneLayout
      items={pageData?.dynamicZone ?? []}
      onRefresh={refresh}
    >
      <h1 className="mt-[20px] px-4 text-right text-[24px] font-bold sm:hidden">
        الرئيسية
      </h1>
    </PageWithDynamicZoneLayout>
  );
});

const HomePageLoading = ({ isLoading }: { isLoading: boolean }) => {
  const isLoadingVisible = useIsLoadingVisibile(isLoading);

  return isLoadingVisible ? <PageSpinner /> : null;
};

export const HomePage: ContentPage = {
  identifier: "PG:HOME",
  page: Home,
};
